import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Prefooterads.css"; // external CSS
import PrefooterAdsSkeleton from "../SkeletonLoader/PrefooterAdsSkeleton";

const Prefooterads = () => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAllAds = async () => {
    try {
      const [res1] = await Promise.all([
        axios.get("https://api.dremerz.net/api/Kalanjiyam_Advertisement_Prefooterad1"),
      ]);
      setAds([...res1.data]);
    } catch (error) {
      console.error("Error fetching ads:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllAds();
  }, []);

  if (loading) return <PrefooterAdsSkeleton />;

  return (
    <div className="container my-4">
      <div className="row g-3 justify-content-center">

        {ads.map((item) => (
          <div
            className="col-12 col-sm-6 col-md-6 col-lg-4 d-flex justify-content-center"
            key={item.id}
          >
            <div className="ad-card">
              <img
                src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                alt="Ad Banner"
                className="ad-image"
                loading="lazy"
              />
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default Prefooterads;
